
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"14","viewBox":"0 0 14 14"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.751 13.273h-3.5a4.617 4.617 0 01-3.447-1.077A4.617 4.617 0 01.728 8.751v-3.5a4.617 4.617 0 011.076-3.447A4.617 4.617 0 015.25.728h1.167a.438.438 0 01.438.438.438.438 0 01-.438.438H5.25a3.84 3.84 0 00-2.827.819 3.84 3.84 0 00-.82 2.827v3.5a3.84 3.84 0 00.82 2.828 3.84 3.84 0 002.827.82h3.5a3.84 3.84 0 002.828-.82 3.84 3.84 0 00.82-2.827V7.584a.438.438 0 11.875 0v1.167a4.617 4.617 0 01-1.076 3.446 4.617 4.617 0 01-3.446 1.076z","fill":"#fff","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M10.797.581a2.52 2.52 0 011.749.868 2.189 2.189 0 010 3.493L7.964 9.531h-.006a2.042 2.042 0 01-1.01.5l-1.752.256a1.6 1.6 0 01-.219.015 1.268 1.268 0 01-.979-.428 1.318 1.318 0 01-.285-1.073l.25-1.75a1.991 1.991 0 01.508-1.02l4.586-4.582a2.482 2.482 0 011.74-.868zM7.346 8.908l4.587-4.584a1.8 1.8 0 00.608-1.032 1.592 1.592 0 00-.608-1.226 1.713 1.713 0 00-1.136-.612 1.684 1.684 0 00-1.122.612L5.088 6.653a1.165 1.165 0 00-.261.52l-.25 1.758a.465.465 0 00.082.377.405.405 0 00.318.123.718.718 0 00.1-.007l1.75-.25a1.224 1.224 0 00.519-.266z","fill":"#fff"}}),_c('path',{attrs:{"data-name":"Vector","d":"M11.584 5.729a.437.437 0 01-.119-.017A4.624 4.624 0 019.46 4.535a4.589 4.589 0 01-1.172-2.006.437.437 0 01.3-.538.437.437 0 01.538.3 3.747 3.747 0 002.577 2.58.437.437 0 01-.119.858z","fill":"#fff","opacity":".4"}})])
          )
        }
      }
    